import { Injectable } from '@angular/core';
import { CanActivate, NavigationStart, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { LoggingService } from '../logging-service/logging.service';
import { AppConfigService } from '../app-config-service/app-config.service';
import { AuthHttpClient } from '../auth-http-service/auth-http.service';
import { UserSessionService } from '../user-session-service/user-session.service';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class AuthGuardService implements CanActivate {

  ////-------------------------------------------------------------------------------------------
  // Author:      Martin Unger
  // Created:     13/12/2017
  // Description: Guards routes buy only allowing them to activate if the user has logged in
  ////-------------------------------------------------------------------------------------------
  private targetRoute: string;
  private isAdminArea: boolean = false;
  completeSubject: Subject<boolean> = new Subject();

  constructor(private router: Router, private loggingService: LoggingService,
    private appConfigService: AppConfigService, http: AuthHttpClient,
    private userSession: UserSessionService, private snackBar: MatSnackBar) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.loggingService.log('Route guard: canActivate', this.appConfigService.LogToConsole);
    return this.userSession.login(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard-service/auth-guard.service.ts